(() => {
  const bundleUrl = '/products/30-day-complete-vitiligo-care-bundle-luminaderm';
  const bundleVariantId = '42551663296594';
  const bundleSellingPlanId = '2580152402';
  const isDesignMode = document.documentElement.classList.contains('shopify-design-mode') || window.Shopify?.designMode;

  const copyReplacements = [
    ['Personalized Support for Your Skin, Joints & Daily Wellness', 'Personalized Support for Your Skin Tone & Daily Wellness'],
    ['Skin, Joints & Daily Wellness', 'Skin Tone & Daily Wellness'],
    ['from skin tone support to joint comfort and daily wellness.', 'from visible skin tone support to daily wellness.'],
    ['from skin tone support to joint comfort and daily wellness', 'from visible skin tone support to daily wellness']
  ];

  const questions = [
    {
      eyebrow: 'Question 1 of 5',
      title: 'What would you like your routine to focus on?',
      helper: 'Choose the answer that feels closest to your current skin support needs.',
      answers: [
        { label: 'A few small visible areas', tags: ['small visible areas'] },
        { label: 'Multiple body areas', tags: ['multiple or more noticeable areas'] },
        { label: 'Long-term visible skin tone care', tags: ['long-term skin tone care'] },
        { label: 'I am not sure yet', tags: ['needs help comparing options'] }
      ]
    },
    {
      eyebrow: 'Question 2 of 5',
      title: 'How long have you been looking for a consistent routine?',
      helper: 'This helps shape the starting point without making the routine feel complicated.',
      answers: [
        { label: 'I am just getting started', tags: ['a clear starting point'] },
        { label: 'Less than 3 months', tags: ['early routine support'] },
        { label: '3 to 12 months', tags: ['consistent 30-day support'] },
        { label: 'More than 1 year', tags: ['longer-term routine support'] }
      ]
    },
    {
      eyebrow: 'Question 3 of 5',
      title: 'Which type of routine feels most practical for you?',
      helper: 'The best routine is the one you can follow comfortably.',
      answers: [
        { label: 'Topical care only', tags: ['topical care'] },
        { label: 'Topical care plus daily wellness support', tags: ['topical care with daily wellness support'] },
        { label: 'A complete 30-day routine', tags: ['a complete 30-day routine'] },
        { label: 'I need help comparing options', tags: ['guided comparison'] }
      ]
    },
    {
      eyebrow: 'Question 4 of 5',
      title: 'How consistently would you like to follow the routine?',
      helper: 'Pick the pace that feels realistic for you right now.',
      answers: [
        { label: 'Start with a simple trial', tags: ['simple first order'] },
        { label: 'Follow it for 30 days', tags: ['30-day consistency'] },
        { label: 'Keep enough supply every month', tags: ['monthly supply preference'], subscribe: true },
        { label: 'I am not sure yet', tags: ['flexible starting option'] }
      ]
    },
    {
      eyebrow: 'Question 5 of 5',
      title: 'How would you prefer to begin?',
      helper: 'You can choose the option that feels easiest to start with today.',
      answers: [
        { label: 'Complete 30-day bundle', tags: ['complete bundle preference'] },
        { label: 'Automatic monthly delivery', tags: ['monthly delivery preference'], subscribe: true },
        { label: 'One-time purchase first', tags: ['one-time purchase preference'], onetime: true },
        { label: 'Review the routine before deciding', tags: ['review before purchase'] }
      ]
    }
  ];

  let step = 0;
  let answers = [];
  const root = document.querySelector('[data-ld-quiz]');

  function getBodyParts() {
    return {
      body: root?.querySelector('[data-ld-quiz-body]'),
      count: root?.querySelector('[data-ld-quiz-count]'),
      bar: root?.querySelector('[data-ld-quiz-bar]'),
      back: root?.querySelector('[data-ld-quiz-back]')
    };
  }

  function replaceTextNodes() {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let text = node.nodeValue;
      copyReplacements.forEach(([from, to]) => { text = text.replaceAll(from, to); });
      if (text !== node.nodeValue) node.nodeValue = text;
    });
  }

  function normalizeQuizLinks() {
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href') || '';
      const text = (link.textContent || '').trim().toLowerCase();
      const isQuizLink = href.includes('skin-love-helper') || href.includes('focus=') || href === '#luminaderm-quiz' || text.includes('quiz');
      if (!isQuizLink) return;
      link.setAttribute('href', '#luminaderm-quiz');
      link.setAttribute('data-ld-open-quiz', 'true');
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  }

  function visibleEnough(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    return rect.width > 80 && rect.height > 28 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.08;
  }

  function findHomepageHero() {
    return document.querySelector('main[data-template="index"] #Hero-hero_jVaWmY') ||
      document.querySelector('main[data-template="index"] .hero-wrapper:first-child .hero') ||
      document.querySelector('main[data-template="index"] section[class*="hero" i]') ||
      document.querySelector('#Hero-hero_jVaWmY');
  }

  function ensureHeroQuizButton() {
    const hero = findHomepageHero();
    if (!hero) return;
    const content = hero.querySelector('.hero__content-wrapper') || hero.querySelector('[class*="content" i]') || hero;
    const possibleButtons = Array.from(hero.querySelectorAll('a[href], button, [role="button"]'));
    let button = possibleButtons.find((el) => {
      const text = (el.textContent || '').toLowerCase();
      const href = el.getAttribute('href') || '';
      return text.includes('quiz') || href.includes('skin-love-helper') || href.includes('focus=') || href === '#luminaderm-quiz';
    });
    if (!button || !visibleEnough(button)) {
      let row = hero.querySelector('.ld-hero-quiz-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'ld-hero-quiz-row';
        content.appendChild(row);
      }
      button = hero.querySelector('.ld-hero-quiz-cta');
      if (!button) {
        button = document.createElement('a');
        button.className = 'ld-hero-quiz-cta';
        row.appendChild(button);
      }
    }
    if (button.tagName === 'A') button.setAttribute('href', '#luminaderm-quiz');
    button.setAttribute('data-ld-open-quiz', 'true');
    button.classList.add('ld-hero-quiz-cta');
    button.textContent = 'Start My Skin Support Quiz';
  }

  function ensureProductQuizPrompt() {
    if (!window.location.pathname.includes('/products/')) return;
    const purchase = document.querySelector('.ld-product-panel .ld-purchase');
    if (!purchase || purchase.querySelector('.ld-product-quiz-prompt')) return;
    const prompt = document.createElement('button');
    prompt.type = 'button';
    prompt.className = 'ld-product-quiz-prompt';
    prompt.setAttribute('data-ld-open-quiz', 'true');
    prompt.textContent = 'Not sure which option fits? Take the 30-second quiz';
    purchase.insertBefore(prompt, purchase.firstElementChild?.nextSibling || purchase.firstChild);
  }

  function resetQuiz() {
    step = 0;
    answers = [];
  }

  function renderQuestion() {
    const parts = getBodyParts();
    if (!parts.body) return;
    const q = questions[step];
    if (parts.count) parts.count.textContent = `${step + 1} / ${questions.length}`;
    if (parts.bar) parts.bar.style.width = `${((step + 1) / questions.length) * 100}%`;
    if (parts.back) parts.back.disabled = step === 0;
    parts.body.innerHTML = `
      <div class="ld-quiz__question">
        <div>
          <span class="ld-quiz__eyebrow">${q.eyebrow}</span>
          <h3>${q.title}</h3>
          <p>${q.helper}</p>
        </div>
        <div class="ld-quiz__answers">
          ${q.answers.map((answer, index) => `<button class="ld-quiz__answer" type="button" data-answer="${index}">${answer.label}</button>`).join('')}
        </div>
      </div>`;
  }

  function recommendation() {
    const selected = answers.flatMap((answer) => answer.tags || []);
    const wantsSubscription = answers.some((answer) => answer.subscribe);
    const wantsOneTime = answers.some((answer) => answer.onetime) && !wantsSubscription;
    const reasons = [];
    if (selected.some((tag) => tag.includes('multiple') || tag.includes('long-term'))) reasons.push('Supports multiple or more noticeable visible skin tone areas');
    if (selected.some((tag) => tag.includes('topical care with daily wellness') || tag.includes('complete'))) reasons.push('Combines topical care with daily wellness support');
    if (selected.some((tag) => tag.includes('30-day') || tag.includes('monthly') || tag.includes('bundle'))) reasons.push('Fits a simple 30-day routine without choosing products one by one');
    if (!reasons.length) reasons.push('Gives you a clear starting point for consistent visible skin tone care');
    while (reasons.length < 3) {
      const fallback = ['Includes both outside topical care and daily supplement support', 'Keeps the routine simple with one complete starting option', 'Lets you choose subscription or one-time purchase before checkout'];
      const next = fallback.find((item) => !reasons.includes(item));
      if (!next) break;
      reasons.push(next);
    }
    return { wantsSubscription, wantsOneTime, reasons: reasons.slice(0, 3) };
  }

  async function addBundleToCart(mode, button) {
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
    }
    const payload = { id: Number(bundleVariantId), quantity: 1 };
    if (mode === 'subscription') payload.selling_plan = Number(bundleSellingPlanId);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Cart add failed');
      window.location.href = '/checkout';
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'Try again';
      }
      const errorEl = root?.querySelector('[data-ld-quiz-error]');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'We could not add this option automatically. Please open the bundle page and choose your option.';
      }
    }
  }

  function renderResult() {
    const parts = getBodyParts();
    const rec = recommendation();
    if (parts.count) parts.count.textContent = 'Ready';
    if (parts.bar) parts.bar.style.width = '100%';
    if (parts.back) parts.back.disabled = false;
    parts.body.innerHTML = `
      <div class="ld-quiz__result">
        <span class="ld-quiz__eyebrow">Your Match</span>
        <h3>Your Match: 30-Day Complete Skin Support Routine</h3>
        <p>Based on your answers, you prefer a consistent routine that combines topical care with daily wellness support.</p>
        <div class="ld-quiz__result-card">
          <strong>Why this fits</strong>
          <ul class="ld-quiz__reasons">
            ${rec.reasons.map((reason) => `<li>${reason}</li>`).join('')}
          </ul>
        </div>
        <div class="ld-quiz__offer" aria-label="Recommended purchase options">
          <button class="ld-quiz__buy ld-quiz__buy--primary" type="button" data-ld-quiz-buy="subscription">Subscribe & Save 25% — $95.24 every 30 days</button>
          <button class="ld-quiz__buy" type="button" data-ld-quiz-buy="onetime">Buy Once — $126.99</button>
          <p>Includes 3 balm tubes + 1 supplement bottle</p>
          <p>Free U.S. shipping · 5–10 business days</p>
          <p>Skip or cancel subscription anytime</p>
          <p>Covered by LuminaDerm's 30-day return policy.</p>
          <p class="ld-quiz__error" data-ld-quiz-error hidden></p>
        </div>
        <a class="ld-quiz__cta" href="${bundleUrl}${rec.wantsSubscription ? '?quiz=subscription' : rec.wantsOneTime ? '?quiz=one-time' : '?quiz=complete-routine'}">Review Full Bundle Page</a>
      </div>`;
  }

  function openQuiz(force = false) {
    if (!root) return;
    if (!force && sessionStorage.getItem('ldQuizSeen') === 'yes') return;
    resetQuiz();
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ld-quiz-open');
    sessionStorage.setItem('ldQuizSeen', 'yes');
    renderQuestion();
  }

  function closeQuiz() {
    if (!root) return;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ld-quiz-open');
  }

  function shouldOpenFromTrigger(trigger) {
    const text = (trigger.textContent || '').trim().toLowerCase();
    const href = trigger.getAttribute('href') || '';
    return trigger.hasAttribute('data-ld-open-quiz') || href.includes('skin-love-helper') || href.includes('focus=') || href === '#luminaderm-quiz' || text.includes('quiz');
  }

  function boot() {
    replaceTextNodes();
    normalizeQuizLinks();
    ensureHeroQuizButton();
    ensureProductQuizPrompt();
  }

  if (root) {
    const parts = getBodyParts();
    parts.body?.addEventListener('click', (event) => {
      const buyButton = event.target.closest('[data-ld-quiz-buy]');
      if (buyButton) {
        addBundleToCart(buyButton.dataset.ldQuizBuy, buyButton);
        return;
      }
      const button = event.target.closest('[data-answer]');
      if (!button) return;
      const answer = questions[step].answers[Number(button.dataset.answer)];
      answers[step] = answer;
      if (step >= questions.length - 1) renderResult();
      else {
        step += 1;
        renderQuestion();
      }
    });
    parts.back?.addEventListener('click', () => {
      if (step <= 0) return;
      answers.pop();
      step -= 1;
      renderQuestion();
    });
    root.querySelectorAll('[data-ld-quiz-close]').forEach((el) => el.addEventListener('click', closeQuiz));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root && !root.hidden) closeQuiz();
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ld-open-quiz], a[href], button');
    if (!trigger || !shouldOpenFromTrigger(trigger)) return;
    event.preventDefault();
    event.stopPropagation();
    openQuiz(true);
  }, true);
  document.addEventListener('shopify:section:load', boot);
  window.LuminaDermQuiz = { open: () => openQuiz(true), close: closeQuiz };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.setTimeout(boot, 600);

  if (!isDesignMode && root) {
    const isHome = window.location.pathname === '/' || window.location.pathname === '';
    if (isHome) window.setTimeout(() => openQuiz(false), 900);
  }
})();
